// extracted by mini-css-extract-plugin
export default {"main":"TipoClaseSelector_main__-hi-+"};